import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AssignedDetailsPanelService } from './assigned-details-panel.service';
import { BehaviorSubject, Subject } from 'rxjs';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { LeadHistoryComponent } from '../lead-history/lead-history.component';

@Component({
  selector: 'app-assigned-details-panel',
  templateUrl: './assigned-details-panel.component.html',
  styleUrls: ['./assigned-details-panel.component.scss']
})
export class AssignedDetailsPanelComponent implements OnInit {
  isLoading: Subject<boolean> = new Subject<boolean>();

  constructor(private assignedDetailsService: AssignedDetailsPanelService, public dialog: MatDialog) { }

  ngOnInit() {
  }

  isVisible = false;
  leadObject: any = {};
  togglePanel(leadObject: any) {
    if (leadObject != '') {
       this.getDetails(leadObject['_id']);
      // this.leadObject = leadObject;
    }
    if (this.isVisible) {
      document.querySelector('.panel')?.classList.add('slide-out');
      setTimeout(() => {
        this.isVisible = false;
      }, 300);
    } else {
      this.isVisible = true;
    }
  }

  getDetails(leadId: any) {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.assignedDetailsService.getAssignedDetails(leadId).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.leadObject = responseData.data;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  openDialog() {
    const dialogRef = this.dialog.open(LeadHistoryComponent, {
      width: '65%',
      height: '95vh',
      data: { leadId: this.leadObject['_id'] }
    });

  }

  @ViewChild('audioDialog', { static: true }) audioDialog!: TemplateRef<any>;
  dialogRef!: MatDialogRef<any>;
  openAudioDialog(){
    this.dialogRef = this.dialog.open(this.audioDialog, {
      width: '400px'
    });
  }

  closeAudio(): void {
    this.dialogRef.close();
  }
}
